import React from 'react';
import _ from 'lodash';
import Status from '../../../shared-components/elements/status/Status';
import {Icon} from '../../../ui-toolkit/elements/Icon/Icon.js';

function EnumFormatter({formatter, entity}) {
    let icon = _.get(formatter.settings.icons, entity);
    let displayName = _.get(formatter.settings.displayNames, entity, ''); // fall back to '': no display name is okay if there is an icon
    let color = _.get(formatter.settings.colors, entity);
    let bgcolor = _.get(formatter.settings.bgcolors, entity);

    return <MemoEnumFormatterContent icon={icon} displayName={displayName} color={color} bgcolor={bgcolor} />;
}

function EnumFormatterContent({icon, displayName, color, bgcolor}) {
    if (icon != null) {
        // eslint-disable-next-line import/namespace
        if (displayName == null) {
            return (
                <Status color={color} bgcolor={bgcolor}>
                    <Icon name={icon} style={{color: color}} />
                </Status>
            );
        } else {
            return (
                <Status color={color} bgcolor={bgcolor}>
                    <Icon name={icon} style={{color: color}} />
                    <span>{displayName}</span>
                </Status>
            );
        }
    } else if (displayName != null) {
        return (
            <Status color={color} bgcolor={bgcolor}>
                {displayName}
            </Status>
        );
    }
    return <i>{displayName}</i>;
}

const MemoEnumFormatterContent = React.memo(EnumFormatterContent);

export default React.memo(EnumFormatter);
